import { SxProps } from 'src/types/theme';

export function makeStyles<T extends Record<string, SxProps>>(styles: T) {
  return styles;
}
